import React, { useRef } from 'react';

import { Dialog } from '@paragon/popup-state';

interface Props {
  readonly placeholder: string;
  readonly submitText: string;
  readonly title: string;
  onSubmitClick: (text: string) => void;
}

const TextInputPrompt = (props: Props) => {
  const textInputRef = useRef<HTMLInputElement>(null);

  return (
    <Dialog
      title={props.title}
      submitText={props.submitText}
      onSubmit={() => props.onSubmitClick(textInputRef.current!.value)}
    >
      <input type="text" id="textInputPopup" placeholder={props.placeholder} ref={textInputRef} />
    </Dialog>
  );
};

export default TextInputPrompt;
